import { getApprovedSops, saveZoneSop, deleteZoneSop } from '../../services/sopService';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { RMSAutocomplete } from '../../../shared/components/form-controls';
import { executeApiAction } from '../../../shared/utility/apiHelper';

const ZoneSopDialog = ({ zoneId, canEdit, existingSopIds, sopLink = null, onClose, onSaved }) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const methods = useForm({
    defaultValues: { ptsSOPID: sopLink?.ptsSOPID ?? null },
    disabled: !canEdit || submitting,
  });
  const selectedSop = useWatch({ control: methods.control, name: 'ptsSOPID' });

  const save = ({ ptsSOPID }) => {
    if (!canEdit || !ptsSOPID || submitting || loading || ptsSOPID === sopLink?.ptsSOPID) return;
    return executeApiAction({
      dispatch,
      setLoading: setSubmitting,
      action: async () => {
        if (ptsSOPID === sopLink?.ptsSOPID) return;
        await saveZoneSop({ ptsParentID: zoneId, ParentType: 'Zone', ptsSOPID });
        if (sopLink?.ptsSOPID) {
          await deleteZoneSop({
            ptsParentID: zoneId,
            ParentType: 'Zone',
            ptsSOPID: sopLink.ptsSOPID,
          });
        }
      },
      onSuccess: onSaved,
    });
  };

  useEffect(() => {
    let active = true;
    executeApiAction({
      dispatch,
      action: getApprovedSops,
      setLoading: (value) => {
        if (active) setLoading(value);
      },
      onSuccess: (rows) => {
        if (!active) return;
        const current = sopLink?.SOP;
        setOptions(
          current && !rows.some((row) => row.ptsSOPID === sopLink.ptsSOPID)
            ? [...rows, { ...current, ptsSOPID: sopLink.ptsSOPID }]
            : rows
        );
      },
    });
    return () => {
      active = false;
    };
  }, [dispatch, sopLink]);

  return (
    <RMSCommonDialog
      open
      title={sopLink ? 'Edit SOP' : 'Add SOP'}
      onClose={() => {
        if (!submitting) onClose();
      }}
      onSave={methods.handleSubmit(save)}
      loading={loading || submitting}
      saveDisabled={
        !canEdit || !selectedSop || loading || submitting || selectedSop === sopLink?.ptsSOPID
      }
      maxWidth="sm"
      fullWidth
      closeOnBackdropClick={false}>
      <FormProvider {...methods}>
        <RMSAutocomplete
          name="ptsSOPID"
          label="SOP"
          options={options.filter(
            (option) =>
              option.ptsSOPID === sopLink?.ptsSOPID || !existingSopIds.includes(option.ptsSOPID)
          )}
          optionValue="ptsSOPID"
          optionLabel="SOPID"
          loading={loading}
          rules={{ required: 'Select an SOP' }}
        />
      </FormProvider>
    </RMSCommonDialog>
  );
};
export default ZoneSopDialog;
